var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrayWorkIcon = function SvgGrayWorkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.501 2.998a1.5 1.5 0 0 0-1.5 1.5V5.5h-1.5c-.859 0-1.503.731-1.503 1.567v3.366c0 .836.644 1.567 1.503 1.567h6.517c.249 0 .503.224.503.567V14l.003.056A2 2 0 0 0 9.994 16V19a2.002 2.002 0 1 0 4.004 0V16c0-.926-.628-1.705-1.482-1.933a1 1 0 0 0 .005-.068v-1.433c0-.836-.644-1.567-1.503-1.567H4.501c-.249 0-.503-.224-.503-.567V7.067c0-.343.254-.567.503-.567H6v.998a1.5 1.5 0 0 0 1.5 1.5H18.49a1.5 1.5 0 0 0 1.5-1.5V6.5h.51a.5.5 0 0 0 0-1h-.51V4.498a1.5 1.5 0 0 0-1.5-1.5zm-.5 1.5a.5.5 0 0 1 .5-.5H18.49a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H7.5a.5.5 0 0 1-.5-.5zm3.994 11.503a1.002 1.002 0 1 1 2.003 0V19a1.002 1.002 0 0 1-2.003 0z",
    clipRule: "evenodd"
  })));
};
export default SvgGrayWorkIcon;